.form {
  padding: 1rem;
  container-type: inline-size;
}

.tipCopy {
  margin: 0;
}

.tipParagraph {
  margin: 0.25rem;
  font-size: 0.875rem;
}

.actions {
  display: flex;
  justify-content: space-between;
  margin-top: 0.75rem;
}
